export const documentStatuses = [
  {
    name: "draft",
    value: "draft",
    color: "orange",
  },
  {
    name: "verification_or_signature",
    value: "verification_or_signature",
    color: "blue",
  },
  {
    name: "under_negotiation",
    value: "under_negotiation",
    color: "purple",
  },
  {
    name: "ready_for_signature",
    value: "ready_for_signature",
    color: "teal",
  },
  {
    name: "signed",
    value: "signed",
    color: "green",
  },
];
